import React, { useContext } from "react";
import { Image } from "web/src/components/markdown/Image";
import { DocsContext } from "../chrome/DocsContext";

type ImageProps = React.ComponentProps<typeof Image>;

export const LanguageDependantImage = (props: ImageProps & { tsImageProps?: ImageProps; jsImageProps?: ImageProps }) => {
  const { tsImageProps, jsImageProps, ...rest } = props;
  const { showTsLanguage } = useContext(DocsContext);

  return <Image {...rest} {...(showTsLanguage ? tsImageProps : jsImageProps)} />;
};
